const ReadMore = () => {

    // Find all read more links on the page
    const links = document.querySelectorAll('[data-read-more]');

    if (links.length) {

    Array.from(links).forEach((link) => {

            // Add a click event to each button
            link.addEventListener('click', event => {

                // Find the corresponding read more content attribute
                let className = event.target.getAttribute('data-read-more');
                // Find the read more content div
                let targetElement = document.querySelector(`[data-read-content="${className}"]`);

                // If the div is on the page, proceed
                if (typeof targetElement != "undefined" && targetElement != null) {
                    // Show the read more content
                    targetElement.classList.add('active');
                    // Hide the read more button
                    link.classList.add('hidden');
                }
            });
        });
    }
}

export default ReadMore;